import React, { useEffect, useState } from 'react';


export default function LoadComponent(){

    return (<>
        <img height={'50px'} src={require('../assets/load/load2.gif')} />
    </>)
}
